@if (options(); as chartOptions) {
  <div class="message-chart" role="img" [attr.aria-label]="chartTitle() || 'Chart'">
    @defer (on viewport) {
      <shared-charts [schema]="chartOptions" />
    } @placeholder {
      <div class="message-chart-placeholder"></div>
    }
  </div>
}
